import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
import { LoadingService } from './services/loading/loading.service';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { UserInfo } from './services/auth/interface/auth.interface';
import { combineLatest, delay, filter, mergeMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isCalcVisible: boolean = false;
  isLoading: boolean = false;
  token: string | null = null;
  user: UserInfo | null = null;
  urlAfterRedirects: string = '';
  environment = environment;

  private destroyRef = inject(DestroyRef);

  constructor(private authService: AuthService,
              private loader: LoadingService,
              private router: Router,
              private route: ActivatedRoute,
              private titleService: Title) {
    this.authService.init();
    this.tokenAndUserSubscription();
    this.checkUrl();

    if (!environment.production) {
      this.routerChangesSubscription();
    }
  }

  // @HostListener('touchmove', ['$event'])
  // onTouchMove(event: TouchEvent): void {
  //   // Allow scrolling on tables, forms, elements with overflow-auto class, and sidebar
  //   const target = event.target as HTMLElement;
  //   if (target.closest('.overflow-auto') || target.closest('table') || target.closest('form') || target.closest('.sidebar')) {
  //     return;
  //   }
  //   event.preventDefault();
  // }

  ngOnInit(): void {
    this.loader.isLoading().pipe(delay(0)).subscribe((value: boolean) => {
      this.isLoading = value;
    })
  }

  tokenAndUserSubscription(): void {
    combineLatest([this.authService.token, this.authService.user ]).subscribe(([token, user]) => {
      this.token = token;
      this.user = user;
    })
  }

  isAdminPanel(): boolean {
    return this.router.url.includes('admin');
  }

  toggleCalcVisible(): void {
    this.isCalcVisible = !this.isCalcVisible;
  }

  private checkUrl(): void {
    this.router.events.pipe(
      filter((e: Event) => e instanceof NavigationEnd)
    ).subscribe((res: Event) => {
      this.urlAfterRedirects = (res as NavigationEnd).urlAfterRedirects;
    })
  }

  private routerChangesSubscription(): void {
    this.router.events.pipe(
      filter((e: Event) => e instanceof NavigationEnd),
      delay(100),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((res) => {
      if (!this.titleService.getTitle().includes('[DEV]')) {
        this.titleService.setTitle('[DEV] ' + this.titleService.getTitle());
      }
    })
  }

}
